import { createContext, useContext } from "react"

import type { PermissionDisplayMap } from "../../types/permissions.types.ts"

export interface PermissionsEditorContextValue {
  displayMap: PermissionDisplayMap | null
  disabled?: boolean
  isUpdating?: boolean
  highlightedKey: string | null
  isOpen: (disclosureId: string, defaultOpen?: boolean) => boolean
  setOpen: (disclosureId: string, open: boolean) => void
}

export const PermissionsEditorContext =
  createContext<PermissionsEditorContextValue>({
    displayMap: null,
    highlightedKey: null,
    isOpen: (_, defaultOpen = false) => defaultOpen,
    setOpen: () => undefined
  })

export const usePermissionsEditor = () => useContext(PermissionsEditorContext)
